import React from 'react';
import { CookiesProvider } from 'react-cookie';
import 'react-datepicker/dist/react-datepicker.css';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import ThemeWrapper from './components/ThemeWrapper';
import SiteTitleProvider from './context/SiteTitleContext';
import './index.css';
import { handleCallback, userManager } from './services/AuthenticationService';
import { store } from './state/store';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container)

root.render(
    <React.StrictMode>
        <CookiesProvider>
            <Provider store={store}>
                <BrowserRouter>
                    <ThemeWrapper>
                        <SiteTitleProvider title='eventbild.se'>
                            <AuthProvider userManager={userManager} onSigninCallback={handleCallback}>
                                <App />
                            </AuthProvider>
                        </SiteTitleProvider>
                    </ThemeWrapper>
                </BrowserRouter>
            </Provider>
        </CookiesProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();




// const App = () => {
//     initFeatures();
//     ...
// }
